import { render, staticRenderFns } from "./ModuleHeader.vue?vue&type=template&id=51435244&scoped=true&"
import script from "./ModuleHeader.vue?vue&type=script&lang=js&"
export * from "./ModuleHeader.vue?vue&type=script&lang=js&"
import style0 from "./ModuleHeader.vue?vue&type=style&index=0&id=51435244&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51435244",
  null
  
)

export default component.exports